import { Swiper } from 'swiper';
import { SwiperOptions } from 'swiper/types';

export class ModalGalleryThumbs {
	private element: HTMLElement;
	private readonly sliderElement: HTMLElement;
	private sliderSettings = (): SwiperOptions => ({
		slidesPerView: 'auto',
		spaceBetween: 4,
	});
	public slider: Swiper;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.sliderElement = this.element.querySelector('.modal-gallery-thumbs__slider');

		this.init();
	}

	public init = ():void => {
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
	};
}
